import {
  useIsBrandPage,
  useIsCategoryPage,
  useIsHomePage,
  useIsOutfitDetailPage,
  useIsStoryPage,
} from '@aboutyou/router';
import {useShowCampaignPhonePopup} from '../../../backend-services/Campaigns/hooks/useShowCampaignPhonePopup';
import {useIsGenericWebCouponBannerEnabled} from '../../WebCouponBanner/utils/useIsGenericWebCouponBannerEnabled';

export const useShowSlideInWebCouponBanner = () => {
  const isActive = useIsGenericWebCouponBannerEnabled();

  const isBrowsePage = useIsHomePage();
  const isCategoryPage = useIsCategoryPage();
  const isBrandPage = useIsBrandPage();
  const isStoryPage = useIsStoryPage();
  const isOutfitPage = useIsOutfitDetailPage();

  const showCampaignPhonePopup = useShowCampaignPhonePopup();

  return (
    isActive &&
    (isBrowsePage ||
      isCategoryPage ||
      isBrandPage ||
      isStoryPage ||
      isOutfitPage) &&
    !showCampaignPhonePopup
  );
};
